var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userData.type == 'admin')?_c('admin-table'):_c('partners-table')}
var staticRenderFns = []

export { render, staticRenderFns }